/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import { mapState, mapMutations } from 'vuex';
import { getIdByQRCode as _getIdByQRCode } from '@/api';
import HomeTodo from './components/HomeTodo';
import Banner from './components/Banner';
import ViewCard from '@/components/Common/ViewCard';
export default {
  name: 'Home',
  components: {
    ViewCard: ViewCard,
    HomeTodo: HomeTodo,
    Banner: Banner,
    ViewBox: ViewBox
  },
  data: function data() {
    return {
      isShowPopupFunc: false,
      showSetting: false,
      menuList: [{
        name: '设备基本信息',
        componentName: 'Info'
      }, {
        name: '企业产品介绍',
        componentName: 'CompanyProfile'
      }, {
        name: '企业服务上报',
        componentName: 'Service'
      }, {
        name: '产品相关资料',
        componentName: 'Information'
      }, {
        name: '服务记录',
        componentName: 'Order'
      }, {
        name: '投诉与建议',
        componentName: 'complaint'
      }],
      bannerList: []
    };
  },
  filters: {
    // 过滤角色
    sysroleFilter: function sysroleFilter(val, list) {
      var role = list && list.find(function (item) {
        return item.type === val;
      }) || {};
      return role.role_name;
    }
  },
  computed: {},
  mounted: function mounted() {},
  created: function created() {// 页面接口重新加载
  },
  methods: {
    funNavClick: function funNavClick(item) {
      this.$router.push({
        name: item.componentName,
        params: {
          code: localStorage.getItem('code')
        }
      });
    },
    // 获取二维码的参数
    getIdByQRCode: function getIdByQRCode(code) {
      var _this = this;

      if (!code) return this.$vux.toast.text('code提取出错');

      _getIdByQRCode({
        code: code
      }).then(function (res) {
        if (res.success && res.data) {
          _this.$router.push({
            name: 'ProductDetail',
            params: {
              id: res.data.cpId,
              productId: res.data.pId,
              customerId: res.data.cId
            }
          });
        } else {
          _this.$vux.toast.text(res.message || '未绑定产品');
        }
      });
    }
  }
};